import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-yunyingbaobiao",
  "use": "icon-yunyingbaobiao-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-yunyingbaobiao\"><path d=\"M810.712 259.289v448.876H752.02V164.918H164.905v640.166c0 53.632-13.142 40.497 40.54 40.497h627.564c53.68 0 40.538 13.135 40.538-40.497V259.289h-62.835z m62.835-58.692c32.415 0 58.692 26.277 58.692 58.692v545.795c0 86.054-13.142 99.19-99.23 99.19H205.444c-86.088 0-99.23-13.136-99.23-99.19V164.918c0-32.415 26.277-58.692 58.691-58.692H752.02c32.414 0 58.692 26.277 58.692 58.692v35.679h62.835z\" /><path d=\"M248.016 368.009h232.907V250.625H248.016z\" /><path d=\"M248.012 706.242V647.55h418.445v58.692zM248.012 556.268v-58.693h418.445v58.693z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/yunyingbaobiao.svg
// module id = l0n1
// module chunks = 5